import React, { useCallback } from 'react'
import styled from 'styled-components'
import BigNumber from 'bignumber.js'
import {
	Button,
	Flex,
	Heading,
	IconButton,
	AddIcon,
	MinusIcon,
	useModal,
} from '../../../../uikit-foodcourt'
import { useLocation } from 'react-router-dom'
import { useTranslation } from 'contexts/Localization'
import { useStake } from 'hooks/useStake'
import { useUnstake, useEmergencyWithdraw } from 'hooks/useUnstake'
import { getBalanceNumber, getFullDisplayBalance } from 'utils/formatBalance'
import DepositModal from '../DepositModal'
import WithdrawModal from '../WithdrawModal'

interface FarmCardActionsProps {
	stakedBalance?: BigNumber
	tokenBalance?: BigNumber
	tokenName?: string
	pid?: number
	addLiquidityUrl?: string
	decimals?: number
	isWithdrawFee100?: boolean
}

const IconButtonWrapper = styled.div`
	display: flex;
	svg {
		width: 20px;
	}
`

const StakeAction: React.FC<FarmCardActionsProps> = ({
	stakedBalance,
	tokenBalance,
	tokenName,
	pid,
	addLiquidityUrl,
	decimals = 18,
	isWithdrawFee100 = false,
}) => {
	const { t } = useTranslation()
	const { onStake } = useStake(pid)
	const { onUnstake } = useUnstake(pid)
	const { onEmergencyWithdraw } = useEmergencyWithdraw(pid)
	const location = useLocation()

	const displayBalance = useCallback(() => {
		const stakedBalanceNumber = getBalanceNumber(stakedBalance, decimals)
		if (stakedBalanceNumber > 0 && stakedBalanceNumber < 0.0001) {
			return getFullDisplayBalance(stakedBalance).toLocaleString()
		}
		return stakedBalanceNumber.toLocaleString()
	}, [stakedBalance])

	const [onPresentDeposit] = useModal(
		<DepositModal
			max={tokenBalance}
			onConfirm={onStake}
			tokenName={tokenName}
			addLiquidityUrl={addLiquidityUrl}
			decimals={decimals}
			isWithdrawFee100={isWithdrawFee100}
		/>,
	)
	const [onPresentWithdraw] = useModal(
		<WithdrawModal
			max={stakedBalance}
			onConfirm={onUnstake}
			tokenName={tokenName}
			decimals={decimals}
			isWithdrawFee100={isWithdrawFee100}
		/>,
	)

	const renderStakingButtons = () => {
		if (stakedBalance.gt(0)) {
			return <Button
				onClick={onEmergencyWithdraw}
			>
				Emergency Withdraw
			</Button>
		}
		return <Button disabled>Pool Ended</Button>
	}

	return (
		<Flex justifyContent="space-between" alignItems="center">
			<Heading color={stakedBalance.eq(0) ? 'textDisabled' : 'text'}>{displayBalance()}</Heading>
			{renderStakingButtons()}
		</Flex>
	)
}

export default StakeAction
